import { render, staticRenderFns } from "./ModuleBalanceCard.vue?vue&type=template&id=a953119e&scoped=true"
import script from "./ModuleBalanceCard.vue?vue&type=script&lang=js"
export * from "./ModuleBalanceCard.vue?vue&type=script&lang=js"
import style0 from "./ModuleBalanceCard.vue?vue&type=style&index=0&id=a953119e&prod&lang=scss&scoped=true"
import style1 from "./ModuleBalanceCard.vue?vue&type=style&index=1&id=a953119e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a953119e",
  null
  
)

export default component.exports